import { Box, FormControl, TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { AffiliateNetworkConfig, MerchantAffiliateNetwork, SocialSnowballConfig } from "src/types/merchants"
import { encryptWithPubkey } from "src/utils/rsa"

interface SocialSnowballInputFormProps {
  handleAffiliateNetworkConfigChange: (newConfig: AffiliateNetworkConfig) => void
  existingConfig: AffiliateNetworkConfig
}

const SocialSnowballInputForm: React.FC<SocialSnowballInputFormProps> = ({handleAffiliateNetworkConfigChange, existingConfig}) => {
  const [password, setpassword] = useState('')
  const [encryptedpassword, setEncryptedpassword] = useState('')
  const [email, setEmail] = useState(existingConfig.socialSnowball?.email)

  // encrypt the api key as the user makes changes to it
  useEffect(() => {
    if (!password) {
      setEncryptedpassword('')// no need to encrypt an empty string
    }  else {
      setEncryptedpassword(encryptWithPubkey(password))
    }
  },[password])

  // set the new state in the merchant object
  useEffect(() => {
    const newConfig = {
      type: MerchantAffiliateNetwork.SOCIAL_SNOWBALL,
      socialSnowball: {
        email: email,
        password: {
          transportEncrypted: encryptedpassword,
        },
      } as SocialSnowballConfig
    }

    handleAffiliateNetworkConfigChange(newConfig)
  },[encryptedpassword, email, handleAffiliateNetworkConfigChange])

  return (
    <Box>
      <FormControl className="formControlsContainer">
        <TextField
          value={email}
          onChange={(e) => {
            setEmail(e.target.value)
          }}
          label='Account Email'
          variant="outlined"
        />
      </FormControl>
      <FormControl className="formControlsContainer">
        <TextField
          value={password}
          onChange={(e) => {
            setpassword(e.target.value)
          }}
          label='Account Password'
          variant="outlined"
        />
      </FormControl>
    </Box>
  )
}

export default SocialSnowballInputForm